import { StartHOC } from 'testania';
import { compose } from 'redux';
import { useSelector, useDispatch } from 'react-redux';
import React, { ReactElement, useEffect } from 'react';

import { selectGender } from 'redux/Onboadring/selectors';
import { setGender, setAgeRange } from 'redux/Onboadring/actions';

import withReadyTranslation from 'HOC/withReadyTranslation';

import { useAnalytics, usePreloadNextPage } from 'hooks';

import StartAgeLibContainer from 'containers/StartContainers/StartAgeLibContainer';

import { ICommonPageProps } from 'types/pages/startPages/commonTypes';

import { getContent } from './config';

function StartAgeFullConfA({ toNextPage, getNextPage, pageInfo }: ICommonPageProps): ReactElement {
    const { sendAnalyticsWithEventLabel, customData } = useAnalytics();
    const dispatch = useDispatch();

    usePreloadNextPage({ getNextPage });

    const gender = useSelector(selectGender);

    useEffect(() => {
        if (!gender) dispatch(setGender('female'));
    }, []);

    const handleToNextPage = (fieldValue: string, index: number) => {
        customData('start_age_conf_full_a__checkbox_policy_consent__click');
        sendAnalyticsWithEventLabel({
            eventLabel: fieldValue,
        });

        dispatch(setAgeRange({ index: index, value: fieldValue }));
        toNextPage();
    };

    const content = getContent(gender, pageInfo.config);

    return (
        <StartAgeLibContainer
            toNextPage={handleToNextPage}
            pageTitle={content.titleData.key}
            pageTitleValues={content.titleData.values}
            cardsData={content.cards}
            hasSubtitle={!!pageInfo?.config?.subtitle}
            hasQuizSubtitle={!!pageInfo?.config?.hasQuizSubtitle}
            disclaimer={pageInfo.config?.disclaimer}
            noFooter
        />
    );
}

export default compose<typeof StartAgeFullConfA>(StartHOC, withReadyTranslation)(StartAgeFullConfA);
